function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

// NOTE: We _always_ use a ponyfill because the spec is still in flux,
// and if the spec (and thus, a native implementation) ends up straying
// far from where it was at the time this lib was last published, it
// may cause user code to fail in unexpected ways.
// Once the spec is stablized, we should switch to using the native
// version when available.
import { ResizeObserver } from '@juggle/resize-observer';
import Observable from 'zen-observable';
import { ensureDOMInstance } from '@hzdg/dom-utils';
var resizeObservers = new Map();
var latestSize = new Map();
var resizeObserver;
function createPayload(entry) {
  var contentBoxSize = entry.contentBoxSize,
    borderBoxSize = entry.borderBoxSize,
    contentRect = entry.contentRect;
  var payload = Object.assign({
    contentBoxSize: contentBoxSize[0],
    borderBoxSize: borderBoxSize[0]
  }, contentRect);
  var frozenPayload = Object.freeze(Object.assign({
    toJSON: function toJSON() {
      return JSON.parse(JSON.stringify(this === frozenPayload ? payload : this));
    }
  }, payload));
  return frozenPayload;
}
function createResizeObserver() {
  resizeObserver = new ResizeObserver(function (entries) {
    var _iterator = _createForOfIteratorHelper(entries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        var element = entry.target;
        var observers = resizeObservers.get(element);
        if (observers) {
          (function () {
            var payload = createPayload(entry);
            latestSize.set(element, payload);
            observers.forEach(function (observer) {
              return observer.next(payload);
            });
          })();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
}
export function create(element) {
  ensureDOMInstance(element, Element);
  return new Observable(function (observer) {
    if (!resizeObserver) createResizeObserver();
    var observers = resizeObservers.get(element);
    if (observers) {
      observers.add(observer);
      var size = latestSize.get(element);
      if (size) observer.next(size);
    } else {
      observers = new Set([observer]);
      resizeObservers.set(element, observers);
      resizeObserver.observe(element);
    }
    return function () {
      if (observers) {
        observers.delete(observer);
        if (observers.size === 0) {
          latestSize.delete(element);
          resizeObservers.delete(element);
          resizeObserver.unobserve(element);
        }
      }
    };
  });
}
export default {
  create: create
};